import React from 'react';

import Skjemautfyller from 'src/components';
import { SKJEMA_URL } from 'src/constants/constants';
import { StepContextProvider } from 'src/contexts/stepContext/stepContextProvider';
import { useAppSelector } from 'src/store/reducers';
import { breadcrumbText_oppgaver, oppgaver_string } from 'src/types/url';
import { getSkjemaNameFromUrl } from 'src/util';

import type { BreadcrumbLink } from '@helsenorge/core-framework/breadcrumb';
import PageRoot from '@helsenorge/core-framework/pageroot';

import { HasFetchedProvider } from './FetchSkjemaContext';
import PageRootWrapper from './RootPageWrapper';
import { SkjemaWrapper } from './SkjemaWrapper';

export const RootComponent = (): React.JSX.Element => {
  const tekniskNavn = getSkjemaNameFromUrl();
  const skjemaUrl = tekniskNavn ? `/${SKJEMA_URL}/${tekniskNavn}${window.location.search}` : `/${SKJEMA_URL}${window.location.search}`;
  const returUrl = useAppSelector(state => state.refero.ui.returUrl);

  const getBreadcrumbLink = (): BreadcrumbLink | undefined => {
    if (returUrl && returUrl.includes(oppgaver_string)) {
      const returUrlDecoded = decodeURIComponent(returUrl);
      return {
        name: breadcrumbText_oppgaver,
        url: returUrlDecoded,
      };
    }
  };

  return (
    <HasFetchedProvider>
      <PageRoot
        hasPageHeader={false}
        redirectTo={skjemaUrl}
        className="page_refero"
        enableSurveys={false}
        breadcrumbLink={getBreadcrumbLink()}
      >
        <PageRootWrapper>
          <SkjemaWrapper>
            <StepContextProvider>
              <Skjemautfyller />
            </StepContextProvider>
          </SkjemaWrapper>
        </PageRootWrapper>
      </PageRoot>
    </HasFetchedProvider>
  );
};
export default RootComponent;
